/* Lavender Farm Simulator — "opening tab" loading bar.
   Tabs can take a second or more to draw, and nothing showed the player that the game was working.
   Now any move to another area (tab, hub, map landmark, "Open Field" style buttons) shows a lavender
   progress pill with a bee riding the bar: "Opening Greenhouse…". If the area takes a while it says so,
   and shows a lavender-growing tip. It hides the moment the new area is on screen.
   Animations run on transform/opacity only, so they keep moving while the game is busy drawing.
   Reads the game's own events (lfg:route-leave / lfg:route-enter) and markup; never edits the save. */
(function () {
  'use strict';
  if (window.__gllfSimLoadbar) return;
  window.__gllfSimLoadbar = true;
  (function () {
    var src = (document.currentScript && document.currentScript.src) || '';
    if (!src || document.getElementById('gllf-sim-loadbar-css') || document.querySelector('link[href*="gllf-sim-loadbar.css"]')) return;
    var l = document.createElement('link'); l.id = 'gllf-sim-loadbar-css'; l.rel = 'stylesheet';
    l.href = src.replace(/gllf-sim-loadbar\.js/, 'gllf-sim-loadbar.css');
    document.head.appendChild(l);
  })();

  var TIPS = [
    'Lavender loves full sun: at least 6 to 8 hours a day.',
    'Good drainage matters more to lavender than rich soil.',
    'Lavender prefers slightly alkaline soil, around pH 6.5 to 7.5.',
    'Water new plants through their first season; established lavender handles dry spells.',
    'Prune after flowering, but never cut back into old, bare wood.',
    'Bees and bumblebees work lavender blooms all summer long.',
    'Angustifolia types are the classic culinary lavenders; lavandins are grown mostly for oil.',
    'Cut bundles for drying when only a few flowers on each spike have opened.'
  ];
  var MIN_SHOW = 450, SLOW = 2500, TIP_AT = 1600, GIVE_UP = 15000;

  var el, fillWrap, beeWrap, titleEl, subEl, tipEl;
  var state = null; /* { route, name, t0, timers[], raf } */

  function build() {
    if (el) return;
    el = document.createElement('div');
    el.className = 'gllf-loadbar';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.hidden = true;
    el.innerHTML =
      '<div class="gllf-loadbar__card">' +
        '<div class="gllf-loadbar__head"><span class="gllf-loadbar__sprig" aria-hidden="true">🪻</span>' +
          '<div class="gllf-loadbar__text"><b class="gllf-loadbar__title"></b><span class="gllf-loadbar__sub"></span></div></div>' +
        '<div class="gllf-loadbar__track" aria-hidden="true">' +
          '<div class="gllf-loadbar__clip"><div class="gllf-loadbar__fillwrap"><div class="gllf-loadbar__fill"><i class="gllf-loadbar__shine"></i></div></div></div>' +
          '<div class="gllf-loadbar__beewrap"><span class="gllf-loadbar__bee">🐝</span></div>' +
        '</div>' +
        '<p class="gllf-loadbar__tip" hidden></p>' +
      '</div>';
    document.body.appendChild(el);
    fillWrap = el.querySelector('.gllf-loadbar__fillwrap');
    beeWrap = el.querySelector('.gllf-loadbar__beewrap');
    titleEl = el.querySelector('.gllf-loadbar__title');
    subEl = el.querySelector('.gllf-loadbar__sub');
    tipEl = el.querySelector('.gllf-loadbar__tip');
  }

  function root() { return document.getElementById('lfg-simulator-root'); }
  function clean(t) { return String(t || '').replace(/[\u{1F000}-\u{1FAFF}☀-➿️‍]/gu, '').replace(/\s+/g, ' ').trim(); }
  function routeName(route) {
    var r = root(), b = r && r.querySelector('[data-tab="' + route + '"]');
    var n = b ? clean(b.textContent) : '';
    return n || (route ? route.charAt(0).toUpperCase() + route.slice(1) : 'your farm');
  }
  function activeView() { var r = root(); return r && r.querySelector('section.lfg-view.active'); }
  function viewReady(route) {
    var r = root(); if (!r) return false;
    var v = route ? r.querySelector('#lfg-view-' + route) : activeView();
    if (!v || v.hidden || !v.offsetParent) return false;
    return v.getBoundingClientRect().height > 60 && v.children.length > 0;
  }

  function coach() {
    var c = document.getElementById('lfg-action-coach-lfg-simulator-root');
    return c && !c.hidden && c.getClientRects().length ? c : null;
  }
  function coachChanged(s) {
    var c = coach(); if (!c) return false;
    var t = c.textContent;
    if (s.name && t.indexOf(s.name + ' didn') >= 0) return true;
    return t !== s.coachText && /didn.t run/i.test(t);
  }
  function setProgress(scale, ms, ease) {
    [fillWrap, beeWrap].forEach(function (x) {
      x.style.transition = 'transform ' + ms + 'ms ' + (ease || 'cubic-bezier(.12,.7,.25,1)');
      x.style.transform = 'translateX(' + ((scale - 1) * 100).toFixed(1) + '%)';
    });
  }

  function start(route, name, fromPrevious) {
    build();
    if (state && state.route === route) return;
    stop(true);
    var prev = activeView();
    var c0 = coach();
    state = { route: route, name: name, t0: Date.now(), timers: [], prev: prev, coachText: c0 ? c0.textContent : '' };
    titleEl.textContent = 'Opening ' + name + '…';
    subEl.textContent = 'Getting everything ready on the farm.';
    tipEl.hidden = true;
    el.classList.remove('is-done', 'is-slow');
    el.hidden = false;
    /* reset to empty with no animation, then glide toward 90% on the compositor */
    setProgress(0, 0);
    void fillWrap.offsetWidth;
    el.classList.add('is-on');
    requestAnimationFrame(function () { setProgress(0.9, 7000); });
    state.timers.push(setTimeout(function () {
      tipEl.textContent = '🌿 ' + TIPS[Math.floor(Math.random() * TIPS.length)];
      tipEl.hidden = false;
    }, TIP_AT));
    state.timers.push(setTimeout(function () {
      el.classList.add('is-slow');
      subEl.textContent = 'Still growing… bigger areas take a few more seconds. No need to click again.';
    }, SLOW));
    state.timers.push(setTimeout(function () { finish(); }, GIVE_UP));
    watch();
  }

  function watch() {
    if (!state) return;
    var s = state;
    (function loop() {
      if (state !== s) return;
      var ready = s.route ? viewReady(s.route) : (activeView() && activeView() !== s.prev && viewReady(''));
      /* the game refused the move (e.g. "Flower Farm needs its Farm Map placement") and says why in its
         action coach — stop right away instead of spinning for 15 seconds */
      if (!ready && Date.now() - s.t0 > 300 && coachChanged(s)) { stop(); return; }
      if (ready) {
        /* wait two frames so the new area has actually painted */
        requestAnimationFrame(function () { requestAnimationFrame(function () { if (state === s) finish(); }); });
        return;
      }
      s.raf = requestAnimationFrame(loop);
    })();
  }

  function finish() {
    if (!state) return;
    var s = state, wait = Math.max(0, MIN_SHOW - (Date.now() - s.t0));
    s.timers.forEach(clearTimeout);
    s.timers = [];
    setTimeout(function () {
      if (state !== s) return;
      setProgress(1, 220, 'ease-out');
      titleEl.textContent = s.name + ' is ready';
      subEl.textContent = '';
      el.classList.add('is-done');
      s.timers.push(setTimeout(function () { if (state === s) stop(); }, 650));
    }, wait);
  }

  function stop(immediate) {
    if (!state) return;
    state.timers.forEach(clearTimeout);
    cancelAnimationFrame(state.raf);
    state = null;
    if (!el) return;
    el.classList.remove('is-on');
    if (immediate) { el.hidden = true; return; }
    setTimeout(function () { if (!state) el.hidden = true; }, 320);
  }

  /* 1) earliest signal: pointer goes down on a tab or hub (paints before the game starts drawing) */
  function fromButton(t) {
    if (!t || t.disabled || t.getAttribute('aria-disabled') === 'true' || t.classList.contains('lfg-stage-locked')) return null;
    if (t.getAttribute('aria-selected') === 'true' || t.classList.contains('active')) return null;
    if (t.hasAttribute('data-tab')) return { route: t.getAttribute('data-tab'), name: clean(t.textContent) };
    if (t.hasAttribute('data-hub')) return { route: '', name: clean(t.textContent) };
    return null;
  }
  document.addEventListener('pointerdown', function (e) {
    if (e.button > 0) return;
    var r = root(); if (!r || !r.contains(e.target)) return;
    var t = e.target.closest('[data-tab], [data-hub]');
    var info = fromButton(t); if (!info) return;
    /* only a tap that ends in a click counts; a scroll or drag cancels */
    var cancel = function () { document.removeEventListener('click', ok, true); };
    var ok = function (ev) { document.removeEventListener('click', ok, true); if (ev.target.closest('[data-tab], [data-hub]') === t) start(info.route, info.name); };
    document.addEventListener('click', ok, true);
    setTimeout(cancel, 1200);
  }, true);
  /* keyboard users */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var info = fromButton(e.target.closest && e.target.closest('[data-tab], [data-hub]'));
    if (info) start(info.route, info.name);
  }, true);

  /* 2) every other way of moving around (map landmarks, "Open Field", journey cards…) */
  document.addEventListener('lfg:route-leave', function (e) {
    var d = e.detail || {}; if (!d.next) return;
    if (state && (state.route === d.next || state.route === '')) { state.route = d.next; state.name = state.name || routeName(d.next); return; }
    if (viewReady(d.next)) return;
    start(d.next, routeName(d.next));
  }, true);
  document.addEventListener('lfg:route-enter', function (e) {
    var d = e.detail || {};
    if (state && state.route === '' && d.route) state.route = d.route;
  }, true);
  /* never leave the bar up if the page is hidden and comes back later */
  document.addEventListener('visibilitychange', function () { if (document.hidden && state) finish(); });
})();
